import { render, staticRenderFns } from "./GlobalSettingsPanelControlsViewMode.vue?vue&type=template&id=6014f453&"
import script from "./GlobalSettingsPanelControlsViewMode.vue?vue&type=script&lang=ts&"
export * from "./GlobalSettingsPanelControlsViewMode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports